/*
 * General configuration settings
 */

// Set in the public/runtime.js file
const apiURL = window?.runtime?.apiURL;

const data = {
  apiURL: apiURL,
  socketServer: window?.runtime?.wsURL,
  userGuide: '/doc/index.html',
  releaseNotes: '/doc/changes_to_linkplanner.html',
  support: 'https://airspan.com/contact/support/',
};
export default data;

/*
 * Return a fully qualified URL for a path relative to the API URL.
 * apiURL is relative for on prem installations, e.g. "/api", so it is
 * resolved against the current page. An absolute url is returned unchanged.
 */
export const resolveApiURL = (url = '') => {
  const base = new URL(`${apiURL}/`, window.location.href);
  return new URL(url, base).href;
};
